import { csx } from '@vtex/admin-ui'

const styles = {
  errorMessage: csx({
    marginTop: '$space-1',
    display: 'block',
    ':empty': {
      display: 'none',
    },
  }),
  content: csx({
    borderRadius: 8,
    padding: '$space-5',
  }),
  container: csx({
    width: 'full',
    marginTop: '$space-1',
    display: 'inline-block',
    ':empty': {
      display: 'none',
    },
    '&.neutral': {
      '& > [data-pp-border="true"]': {
        border: '$neutral',
      },
    },
    '&.critical': {
      '& > [data-pp-border="true"]': {
        border: '$form.critical',
      },
    },
  }),
}

export default styles
